export const environment = {
  production: true,
  serviceUrl: 'https://be.videobyte.com',
  vastUrl: 'https://x.videobyte.com',
  epgGenresService: 'https://epg.videobyte.com/main/api/genre',
  epgKeywordsService: 'https://epg.videobyte.com/main/api/keyword',
  mixpanelToken: '24ad6df3bb051d90f318d28aa5ba2335',
  reportingApiUrl: 'https://reporting.videobyte.com',
  e2eEmail: '',
  e2ePassword: '',
  features: {
    pacingNav: true,
  },
  okta: {
    enabled: true,
    issuer: 'https://login.kargo.com/oauth2/default',
    clientId: '0oayd5pugsP3AKYTA4x7',
    redirectUri: 'https://app.videobyte.com/',
  },
};
